<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content relative bg-white rounded-xl">
                <div class="relative">
                    <img src="@/assets/bg/bg-badge.png" alt="">
                    <div class="img-position">
                        <VeProgress v-if="getPercent() > 0 && getPercent() < 100"
                            :progress="getPercent()"
                            :size="125"
                            empty-color="transparent"
                            color="#53b546"
                            :dot="`10 ${lineColor}`"
                            :thickness="3"
                        >
                            <div class="wrapper-img"
                                :class="{'full': getPercent() == 100}">
                                <img :src="getImgUrl()" alt="" />
                                <div class="text-22 text-white"
                                :class="{'text-green-1': getPercent() != 100}"
                                >{{getPercent()}}%</div>
                            </div>
                        </VeProgress>
                        <div v-else class="wrapper-no-progress relative">
                            <div class="wrapper-img"
                                :class="{'full': getPercent() == 100}">
                                <img :src="getImgUrl()" alt="" />
                                <div class="text-center text-22 text-white"
                                :class="{'text-green-1': getPercent() != 100}"
                                >{{getPercent()}}%</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-full rounded-xl px-4 pb-4 ">
                    <div class="text-center text-xl pt-3" v-html="title"></div>
                    <div class="text-center text-22 pb-5 pt-3 font-main-regular text-gray-1" v-html="message"></div>

                </div>

                <div class="close-position" @click="clickClose()">
                    <img src="@/assets/icon/ic-close-circle.svg" alt="">
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import { VeProgress } from "vue-ellipse-progress";//https://github.com/setaman/vue-ellipse-progress/tree/v2-dev
export default {
    name: "BadgeAlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },

    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,

            badge: null,
        };
    },
    components: {
        VeProgress
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.badge = config.badge;

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickClose: function () {
            this.hide();
        },
        getPercent: function() {
            return this.badge.Percentage * 100;
        },
        getImgUrl: function() {
            let imgUrl = ConfigManager.getApiUrl()  + "/badge/" + this.badge.PartitionKey + "/picture"
            if (!this.badge.IsObtain) {
                imgUrl += "?disable=true";
            }
            return imgUrl;
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        overflow: unset;

        .modal-content {
            overflow: unset;
        }

        .close-position {
            position: absolute;

            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .wrapper-no-progress {
        width: 125px;
        height: 125px;
    }

    .wrapper-img {
        width: 115px;
        height: 115px;
        background-color: white;
        border-radius: 100%;
        overflow: hidden;
        margin: auto;

        &.full {
            background-color: #53b546;
        }

        img {
            width: 70px;
            height: 70px;
            margin: 10px auto 0 auto;
        }
    }
    .img-position {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
